module.exports = __webpack_public_path__ + "media/icons/tablica_rejestracyjna@2x-b0b14af3.png";